import React from 'react';
import {Box, Flex, Spinner} from '@chakra-ui/react';
import {useInfiniteGlobalSearchWithParamsAndLocation} from '../../../hooks/useFetchGlobalSearch';
import useGetUserLocation from '../../../hooks/useUserLocation';
import OfferCard from '../../../components/Articles/Offers/OfferCard';

const PerkCarousel = () => {
  const userLocation = useGetUserLocation();

  const isProduction = process.env.NODE_ENV === 'production';
  const insiderClubInterestId = isProduction ? '294' : '212';

  const fetchMonthlyOffers = useInfiniteGlobalSearchWithParamsAndLocation({
    type: 'offer',
    lat: userLocation?.data?.latitude,
    long: userLocation?.data?.longitude,
    'topics[]': insiderClubInterestId,
    term: '',
    orderBy: 'ends_at',
    sort: {by: 'ends_at', direction: 'asc'},
    month: 'next',
  });

  const offers: any[] =
    fetchMonthlyOffers.data?.pages.flatMap((page: any) => page.data.data) || [];

  if (fetchMonthlyOffers.isLoading && offers.length === 0) {
    return (
      <Flex h="200px" align="center" justify="center">
        <Spinner thickness="3px" speed="0.65s" color="lightBlue" size="md" />
      </Flex>
    );
  }

  if (offers.length === 0) {
    return null;
  }

  return (
    <Flex
      gap={3}
      pl={5}
      pr={5}
      pb={3}
      overflowX="auto"
      sx={{
        '::-webkit-scrollbar': {display: 'none'},
        scrollbarWidth: 'none',
      }}>
      {offers.map((offer) => (
        <Box key={offer.id} flexShrink={0} width="280px">
          <OfferCard offer={offer} fullCard={true} showBookmark={false} showExclusive={true} />
        </Box>
      ))}
    </Flex>
  );
};

export default PerkCarousel;
